import React from "react";
import {DateFormat, getDateFromDateString} from "../../Helpers/DateTimeHelper";
import {parse, formatISO, startOfDay, endOfDay} from "date-fns";
import TextField from "@mui/material/TextField";
import DateRangeButton from "../Buttons/DateRangeButton";

const DateRangeInputRow = (props) => {

    const handleStartDateChange = (startDate) => {
        startDate = startOfDay(parse(startDate, DateFormat.MYSQL_DATE, new Date()));
        props.onChange(formatISO(startDate), props.endDate);
    }

    const handleEndDateChange = (endDate) => {
        endDate = endOfDay(parse(endDate, DateFormat.MYSQL_DATE, new Date()));
        props.onChange(props.startDate, formatISO(endDate));
    }

    const handleDateRangeChange = (startDate, endDate) => {
        props.onChange(startDate, endDate);
    }

    return (
        <div className="date-range-input-row grid-x grid-margin-x">
            <div className="cell small-5">
                <TextField
                    type="date"
                    name="dateRangeStart"
                    value={getDateFromDateString(props.startDate)}
                    onChange={(e) => handleStartDateChange(e.target.value)}
                    InputLabelProps={{shrink: true,}}
                />
                <i className="fa fa-arrow-right range-divider-icon"/>
            </div>
            <div className="cell small-5">
                <TextField
                    type="date"
                    name="dateRangeEnd"
                    value={getDateFromDateString(props.endDate)}
                    onChange={(e) => handleEndDateChange(e.target.value)}
                    InputLabelProps={{shrink: true,}}
                    inputProps={{
                        min: getDateFromDateString(props.startDate)
                    }}
                />
            </div>
            <div className="cell auto">
                <DateRangeButton
                    onChange={handleDateRangeChange}
                    startDate={props.startDate}
                    endDate={props.endDate}
                    className="margin-bottom-1"
                    isCentered={true}
                    isSmall={true}
                    hideBadge={true}
                />
            </div>
        </div>
    );
}

export default DateRangeInputRow;

